import React, { Component } from "react";
import "./Splash.css";
import { Redirect } from "react-router-dom";
import LoaderLogo from "../../components/Loader/LoaderLogo";
import { greeting } from "../../portfolio";
import churchLogo from "../../assets/images/churchlogo.png";

function AnimatedSplash(props) {
  return (
    <div className="logo_wrapper">
      <div className="screen" style={{ backgroundColor: props.theme.splashBg }}>
        <img
          src={churchLogo}
          alt="Profile photo"
          className="splash-profile-photo"
          id="logo"
        />
        <div className="splash-title-container">
          <h1 className="splash-title" style={{ color: "#FFFFFF" }}>
            {greeting.title}
          </h1>
          <p className="splash-subtitle" style={{ color: "#E0F5F0" }}>
            {greeting.logo_name}
          </p>
        </div>
      </div>
    </div>
  );
}

class Splash extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }

  componentDidMount() {
    this.id = setTimeout(() => this.setState({ redirect: true }), 5500);
  }

  componentWillMount() {
    clearTimeout(this.id);
  }

  render() {
    return this.state.redirect ? (
      <Redirect to="/home" />
    ) : (
      <AnimatedSplash theme={this.props.theme} />
    );
  }
}

export default Splash;
